import { Ability } from '@casl/ability';
import { initialAbility } from './initialAbility';
import { getUserRole } from '@services/authentificationServices';
import { defineRulesFromRoles } from '@src/utility/abilitiesFromRoles';

// Create a single ability instance with initial rules
const ability = new Ability(initialAbility);

// Helper to update ability from current user role
export function updateAbilityFromCurrentUser() {
  const role = getUserRole();
  const abilityForUser = defineRulesFromRoles(role || []);
  ability.update(abilityForUser.rules);
}

// Helper to reset ability
export function resetAbilityToGuest() {
  const abilityForGuest = defineRulesFromRoles(['guest']);
  ability.update(abilityForGuest.rules);
}

export default ability;

